<template>
  <!--最外层包裹-->
  <div class="detais-wrap">
    <!--右侧包裹-->
    <div id='detais-warp' class="wrapper">
      <div class="topimg">
        <div ref="titleimg"></div>
      </div>
      <!--滚动列-->
      <div class="details">
        <h2 v-html="basicTitle">{{basicTitle}}</h2>
        <hr style="width: 100%">
        <div class="details-content Richtext" ref="Richtext" @contextmenu.prevent="show($event)" v-html="basicContent">
          {{basicContent}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getUserToken} from '@/config/config.js'
  import {getdetais} from '@/api/detais.js'

  export default {
    data() {
      return {
        basicTitle: "",
        basicContent: "",
        basictopimg: ""
      }
    },
    mounted() {
      getUserToken();
      this.initdetais()

    },
    methods: {
      show(e) {
        return
      },
      initdetais() {
        let id = this.$route.params.id.split('&&')[0];
        let code = this.$route.params.id.split('&&')[1];
        if (code == 1) {
          this.$refs.titleimg.className = "sjjkz"
        } else if (code == 2) {
          this.$refs.titleimg.className = "mjls"
        } else if (code == 3) {
          this.$refs.titleimg.className = "zyzs"
        }
        getdetais(id).then((res) => {
          if (res.code == 200 && res.data) {
            this.basicTitle = res.data.basicTitle;
            this.basicContent = res.data.basicContent
          }
        }).catch(() => {

        })
      }

    }
  }
</script>
<style scoped>
  .sjjkz, .mjls, .zyzs {
    position: absolute;
    left: 50%;
    top: 0px;
    transform: translateX(-50%);
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    z-index: 10000;
  }

  .sjjkz {
    background: url("../../assets/img/sjjkz.png");
  }

  .mjls {
    background: url("../../assets/img/App.vue.png");
  }

  .zyzs {
    background: url("../../assets/img/zyzszx.png");
  }

  .detais-wrap {
    width: 100%;
    height: 100%;
    text-align: center;
    overflow-y: scroll;
  }

  #detais-warp {
    display: inline-block;
    box-sizing: border-box;
    width: 1800px;
    height: 100%;
    padding: 20px;
  }

  .topimg {
    position: relative;
    width: 100%;
    height: 250px;
    display: inline-block;
    background: url("../../assets/img/tophongqi.png") center center / cover no-repeat;
  }

  .details {
    text-align: left;
  }

  .details h2 {
    font-family: MicrosoftYaHei;
    font-size: 36px;
    color: #aa0000;
    margin-top: 18px;
    margin-bottom: 16px;
  }

  .details .details-content {
    margin: 0 auto;
    box-sizing: border-box;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #000000;
    overflow: hidden;
    padding: 30px 0px;
    padding-bottom: 100px;

  }

  .topimg > div {
    width: 700px;
    height: 115px;
    margin-top: 70px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Details/index.vue